/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Base,
    BaseFromJSON,
    BaseFromJSONTyped,
    BaseToJSON,
    SponsoredRewardResponse,
    SponsoredRewardResponseFromJSON,
    SponsoredRewardResponseFromJSONTyped,
    SponsoredRewardResponseToJSON,
    TimeStamps,
    TimeStampsFromJSON,
    TimeStampsFromJSONTyped,
    TimeStampsToJSON,
} from './';

/**
 * Collection contains the user\'s reward stats/progress.
 * @export
 * @interface SponsoredGuildCompetition
 */
export interface SponsoredGuildCompetition {
    /**
     * Mongo id of the competition
     * @type {string}
     * @memberof SponsoredGuildCompetition
     */
    id: string;
    /**
     * Brand name to display on guild page
     * @type {string}
     * @memberof SponsoredGuildCompetition
     */
    sponsorBrandName: string;
    /**
     * Image to display on guild page.
     * @type {string}
     * @memberof SponsoredGuildCompetition
     */
    promotionImage: string;
    /**
     * 
     * @type {Array<SponsoredRewardResponse>}
     * @memberof SponsoredGuildCompetition
     */
    rewards: Array<SponsoredRewardResponse>;
    /**
     * 
     * @type {number}
     * @memberof SponsoredGuildCompetition
     */
    runningMonth: number;
    /**
     * 
     * @type {number}
     * @memberof SponsoredGuildCompetition
     */
    runningYear: number;
    /**
     * 
     * @type {string}
     * @memberof SponsoredGuildCompetition
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof SponsoredGuildCompetition
     */
    brandUrl: string;
    /**
     * 
     * @type {number}
     * @memberof SponsoredGuildCompetition
     */
    createdAt: number;
    /**
     * 
     * @type {number}
     * @memberof SponsoredGuildCompetition
     */
    updatedAt: number;
}

export function SponsoredGuildCompetitionFromJSON(json: any): SponsoredGuildCompetition {
    return SponsoredGuildCompetitionFromJSONTyped(json, false);
}

export function SponsoredGuildCompetitionFromJSONTyped(json: any, ignoreDiscriminator: boolean): SponsoredGuildCompetition {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'sponsorBrandName': json['sponsorBrandName'],
        'promotionImage': json['promotionImage'],
        'rewards': ((json['rewards'] as Array<any>).map(SponsoredRewardResponseFromJSON)),
        'runningMonth': json['runningMonth'],
        'runningYear': json['runningYear'],
        'description': json['description'],
        'brandUrl': json['brandUrl'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
    };
}

export function SponsoredGuildCompetitionToJSON(value?: SponsoredGuildCompetition | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'sponsorBrandName': value.sponsorBrandName,
        'promotionImage': value.promotionImage,
        'rewards': ((value.rewards as Array<any>).map(SponsoredRewardResponseToJSON)),
        'runningMonth': value.runningMonth,
        'runningYear': value.runningYear,
        'description': value.description,
        'brandUrl': value.brandUrl,
        'createdAt': value.createdAt,
        'updatedAt': value.updatedAt,
    };
}


